const htmlTestString = `
  <h2>CSIG · 腾讯云 <a href="#">腾讯云</a></h2>
  <ul>
    <li>腾讯云AI体验中心 · 微信小程序</li>
    <li>Soda 速搭 · 前端搭建解决方案</li>
    <li>腾讯罗盘TBI · 商业智能分析工具</li>
    <p>研发负责人全栈开发 负责整个 <b>小程序</b> 的架构设计及研发，将页面场景规范配置化，
    利用小程序云开发 <i>Node.js</i> 能力完成AI接口调用。 
    在原生小程序的写法基础上，基于gulp开发轻量型小程序工程化工具，实现单文件页面组件化开发、依赖处理等能力；
    封装小程序非侵入式语法增强类库，拓展数据状态管理、事件管理、计算属性等能力。</p>
  </ul>
`
const htmlTestEdu =
 `
  <ul>
<li>Planned, developed, tested, deployed, and maintained web applications. </li>
<li>Provided effective troubleshooting and remediation for web applications. </li>
<li>Wrote SQL statements and stored procedures. </li>
<li>Worked well independently and within a team setting. </li>
<li>Effectively translated client requirements into application designs and systems requirements. </li>
<li>Followed policies and procedures related to application methods and quality standards at all times. </li>
  </ul>
`
const testData = {
        "basicInfo": {
            "title": "高级前端工程师", 
            "name": "张飞云", 
            "avatar": "http://vue-maker.oss-cn-hangzhou.aliyuncs.com/vue-marker/d8BmbdLwg6toZsbiEkvpoC-7.jpg", 
            "location": "上海", 
            "cellphone": "136****1234", 
            "email": "vikingmute@test.com", 
            "birth": "2021/06"
        }, 
        "links" : [ 
            {
                "name" : "Github",
                "src" : "https://github.com/vikingmute"
            }, 
            {
                "name" : "个人站点",
                "src" : "https://vikingz.me"
            }, 
            {
                "name" : "LinkedIn",
                "src" : "https://linkedin.com/vikingmute"
            }
        ],
        "sections": [
            {
                "id": "123", 
                "name": "工作经历", 
                "type": "empolyment", 
                "columns": 'one',
                "data": [
                    {
                        "title": "腾讯科技", 
                        "subTitle": "前端工程师", 
                        "startDate": "2020/09", 
                        "endDate": "PRESENT", 
                        "city": "成都", 
                        "description": htmlTestString
                    },
                    {
                        "title": "字节跳动", 
                        "subTitle": "前端工程师", 
                        "startDate": "2019/09", 
                        "endDate": "2020/08", 
                        "city": "上海", 
                        "description": htmlTestEdu
                    }
                ]
            }, 
            {
                "id": "234", 
                "name": "教育经历", 
                "type": "education", 
                "columns": 'two',
                "position": "side",
                "data": [
                    {
                        "title": "湖南大学", 
                        "subTitle": "学士", 
                        "startDate": "2020/09", 
                        "endDate": "2021/06", 
                        "city": "软件工程", 
                        "description": "test description"
                    }, 
                    {
                        "title": "湖南大学", 
                        "subTitle": "硕士", 
                        "startDate": "2020/09", 
                        "endDate": "PRESENT", 
                        "city": "软件工程", 
                        "description": "test description"
                    }
                ]
            }, 
            {
                "id": "345", 
                "name": "专业技能", 
                "type": "skills", 
                "tagStyle": true,
                "data": [
                    {
                        "title": "Javascript", 
                    }, 
                    {
                        "title": "CSS", 
                    },
                    {
                        "title": "Node.js", 
                    },
                    {
                        "title": "React", 
                    },
                    {
                        "title": "Vue.js", 
                    }
                ],
                "position": "main"
            }
        ]
    };

    export default testData